import { Grid } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  padding-right: 10px;
  padding-left: 10px;
`;

export const ConferenceSearchNumber = lib.styled(Grid)`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 47px;
  margin-top: -10px;
  margin-bottom: 10px;
  border-radius: 10px;
  background-color: ${colors.lightGreen};
  box-shadow: 0 1px 6px 0 rgba(32, 33, 36, .28);

  input {
    border-radius: 10px;
    background-color: transparent;
    outline: 0;
    border: 0;
    width: 100%;
    display: flex;
    font-size: ${(props: any) => (props.qty > 0 ? 20 : 13)}px;
    flex: 1;
    max-height: 45px;
    min-height: 45px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .divider {
    height: 1px;
    width: 100%;
    background-color: ${colors.lightGreen02};
  }

  .icon {
    color: #6cf56c;
    padding-left: 5px;
  }
`;

export const ActionsContainer = lib.styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  min-height: 40px;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0px;
    cursor: pointer;
    width: 90px;
    height: 25px;
    border: 1px solid ${colors.lightGray06};
    border-radius: 30px;
    margin-right: 5px;

    &:last-child {
      margin-right: 15px;
    }

    .icon-conference {
      margin-right: 5px;
      div {
        height: 15px;
      }
      svg {
        width: 20px;
        height: 15px;
      }
      path {
        fill: ${colors.green04};
      }
    }

    span {
      font-size: 11px;
      color: ${colors.darkGray01};
    }
  }
`;
